module.exports = __webpack_public_path__ + "media/packs/user-cards/images/warning-58cc6b467575ff1a0d35ed84b38779e1.svg";